// @flow
import * as React from "react"
import Button from "components/Button"
import { Text } from "componentsStyled/Typography/Texts"
import ModalContent from "modals/_Content"
import ModalControls from "modals/_Controls"
import PoweredBy from "modals/CreditCard/CreditCardForm/Input/PoweredBy"
import CardBrand from "pages/Account/Routes/Subpages/Payments/Content/CardBrand"
import { CardInfo } from "pages/Account/Routes/Subpages/Payments/Content/styled"

type Props = {|
  data: {
    brand: string,
    last4: string,
  },
  loading: boolean,
  submit: Function,
  planTitle: string,
  promocode?: string,
  currentStep?: string,
  finalStep?: string,
|}

const ConfirmPayment = ({ data, planTitle, loading, submit, promocode, currentStep, finalStep }: Props) => (
  <React.Fragment>
    <ModalContent>
      <center><PoweredBy /></center><br />
      <CardInfo>
        <Text>Current card: </Text>
        <CardBrand brand={data.brand} />
        <Text book black>
          •••• {data.last4}
        </Text>
      </CardInfo><br />
    </ModalContent>
    <ModalControls column>
      {currentStep && finalStep
        ? <Text black center>
          Step <Text inline black bold>{currentStep}</Text> of {finalStep}
        </Text>
        : ""}
      <Button fullwidth loading={loading} onClick={() => submit(promocode)}>
        Confirm payment
      </Button>
    </ModalControls>
  </React.Fragment>
)

export default ConfirmPayment



// WEBPACK FOOTER //
// ./src/modals/SubscribePlan/ConfirmPayment/index.js